const t = typeof window < "u", s = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (o, n) => (n ? "-" : "") + o.toLowerCase()), a = (e) => !!(e && typeof e.then == "function");
export {
  t as I,
  a as i,
  s as k
};
//# sourceMappingURL=helper-BIBe7yYh.js.map
